import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PROFILE_QUERY_KEY } from '~/features/auth/api/useProfile'

type Response = {
    uuid: string
    status: number
}

export const useCheckTransaction = () => {
    const queryClient = useQueryClient()

    return useMutation<Response, unknown, unknown>({
        mutationFn: async ({ uuid }) => {
            const resp = await fetch(`/api/bank/deposit/solana_usdc/${uuid}`, {
                method: 'GET',
            })
            return await resp.json()
        },
        retry: false,
        onSuccess: (data) => {
            const { status, uuid } = data
            if (status === 2) {
                queryClient.invalidateQueries(['balance'])
                // A confirmed deposit is what ticks "make your first deposit" on the onboarding
                // checklist, and the profile endpoint derives that from the transaction table. It
                // was left stale here, so the tick only appeared on the next refetch-on-focus --
                // which reads as the checklist lagging a few minutes behind the money.
                queryClient.invalidateQueries([PROFILE_QUERY_KEY])
            }
            queryClient.setQueriesData<DeposiListResponse>(['deposit.solana_usdc.list'], (list) => {
                const { data } = list
                const deposit = data.find((item) => item.uuid == uuid)
                const depositIndex = data.findIndex((item) => item.uuid == uuid)
                const newData = data.slice(0)
                newData[depositIndex] = { ...deposit, status }
                if (deposit) {
                    return {
                        ...list,
                        data: newData,
                    }
                }
            })
        },
    })
}
